<template>
  <MainLayoutV2 section="landing">
    <div id="section1_container">
      <div id="section1">
        <div id="section1_subcontainer">
          <h1>ESCAPE <br /><span class="alt">THE</span> VOID.</h1>

          <p><b>Dev Null Productions</b> crafts immersive gaming experiences
          by fusing intricate mechanics, creative storytelling, and
          detailed world design. Our team of seasoned developers and
          creatives combines major studio expertise with innovative
          engineering to create well-executed fantasy adventures that
          are intuitive to begin yet become progressively challenging as
          you explore.</p>

          <div id="section1_subsubcontainer">
            <a class="link_button" href="https://thelongesttale.com">
              THE LONGEST TALE
            </a>

            <div id="learn_more_container">
              <router-link to="/mission" id="learn_more">
                Learn More
                <img src="@/assets/imgs/new_arrow-right.svg" style="width: 16px"/>
              </router-link>
            </div>
          </div>
        </div>

      </div>

      <div id="scroll_down_container">
	<div id ="scroll_down_subcontainer">
          <img src="@/assets/imgs/ScrollDown.svg" id="scroll_down" />
	</div>
      </div>
    </div>

    <div id="section2_container">
      <div id="section2">
        <div id="section2_subcontainer1">
          <img src="@/assets/imgs/new_logo_symbol_x_shuriken_inverted.svg" id="logo" />

          <h1>Where Every Pixel Tells a Tale</h1>

          <p>For gamers seeking immersive, story-driven video games,
          <b>Dev Null Productions</b> is an indie game studio that creates
          well-executed intricate fantasy adventures offering meticulously
          crafted worlds and progressively challenging gameplay.</p>
        </div>

        <div id="section2_subcontainer2">
          <div id="section2_subsubcontainer2">
            <h1>THE LONGEST TALE</h1>

            <p>From dark brooking woods haunted with spirits to vibrant hot
            deserts which nomads must traverse, <b>The Longest Tale</b> is a
            journey of wonder and imagination.</p>

            <a class="link_button" href="https://store.steampowered.com/app/3507360/The_Longest_Tale/" id="preorder">
              <div>WISHLIST NOW</div>
              <img src="@/assets/imgs/Steam.svg" />
            </a>
          </div>
        </div>
      </div>

      <div id="section2_subcontainer3">
        <div id="section2_subcontainer3_title">
          <span id="news_title">NEWS AND ANNOUNCEMENTS</span>
          <span id="see_all_news">
            <router-link to="/news">
              SEE ALL
              <img src="@/assets/imgs/new_arrow-right.svg" style="width: 16px"/>
            </router-link>
          </span>
        </div>

        <LandingPosts />
        <LandingSubscribe />

      </div>
    </div>
  </MainLayoutV2>
</template>

<script>
import MainLayoutV2 from '@/components/V2/layout/MainLayoutV2'
import LandingPosts from '@/components/V2/LandingPosts'
import LandingSubscribe from '@/components/V2/LandingSubscribe'

export default {
  name: 'LandingV2',
  components: {
    MainLayoutV2,
    LandingPosts,
    LandingSubscribe
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#section1_container{
  background-image: url("~@/assets/imgs/home-header-bg-v2.png");
  background-size: cover;
  background-position-x: center;
  background-position-y: bottom;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 90vh;
}

#main_layout_v2.xl #section1_container{
  min-height: 100vh;
}

#main_layout_v2.lg #section1_container{
  background-position-x: calc(100vw - 1500px);
}

#main_layout_v2.md #section1_container{
  background-position-x: calc(100vw - 1250px);
}

#main_layout_v2.sm #section1_container{
  background-position-x: calc(100vw - 1000px);
}

#main_layout_v2.xs #section1_container{
  background-position-x: calc(100vw - 700px);
}

#section1{
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  font-family: Alliance No2;
}

#main_layout_v2.lg #section1{
  width: 80%;
}

#main_layout_v2.xs #section1{
  width: 90%;
}

#section1_subcontainer{
  background-image: linear-gradient($grey-5-alpha62, $black-alpha62);
  border: 1px solid $eerie-black;
  border-radius: 15px;
  color: $white;
  width: 70%;
  padding: 50px;
  padding-left: 65px;
  backdrop-filter: blur(1px);
}

#main_layout_v2.xl #section1_subcontainer,
#main_layout_v2.lg #section1_subcontainer{
  max-width: 57%;
}

#main_layout_v2.md #section1_subcontainer{
  width: 85%;
}

#main_layout_v2.sm #section1_subcontainer,
#main_layout_v2.xs #section1_subcontainer{
  width: 100%;
  padding: 17px;
}

#section1_subsubcontainer{
  display: flex;
  gap: 25px;
}

#main_layout_v2.xs #section1_subsubcontainer{
  flex-direction: column;
  gap: 7px;
}

#section1_subsubcontainer a{
  font-family: Bricolage Grotesque ExtraBold;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-decoration: none;
  color: $white;
}

#section1_subsubcontainer .link_button{
  padding: 7px 15px;
}

#main_layout_v2.xs #section1_subsubcontainer .link_button{
  max-width: 200px;
  text-align: center;
}

#learn_more_container{
  padding-top: 5px;
}

#learn_more{
  border-bottom: 1px solid $sunset-coral;
  margin-top: 5px;
}

#learn_more:hover{
  text-decoration: none;
}

#section1 h1{
  font-size: calc(3rem + 1vw);
  font-family: Sunset Gothic Pro Heavy;
  line-height: 0.9;
}

#section1 h1 .alt{
  color: $sunset-coral;
}

#main_layout_v2.xs #section1 h1{
  font-size: 2.5rem;
}

#main_layout_v2.xs #section1 p{
  font-size: 0.9rem;
}

#scroll_down_container{
  position: absolute;
  top: calc(100vh - 125px);
  width: 100%;
}

#main_layout_v2.lg #scroll_down_container,
#main_layout_v2.md #scroll_down_container{
  top: calc(100vh - 200px);
}

#main_layout_v2.xs #scroll_down_container{
  top: calc(100vh - 175px);
}

#scroll_down_subcontainer{
  width: 70%;
  margin: auto;
  display: flex;
  justify-content: flex-end;
}

#main_layout_v2.lg #scroll_down_subcontainer{
  width: 80%;
}

#main_layout_v2.xs #scroll_down_subcontainer{
  width: 90%;
}

#scroll_down{
  width: 50px;
}

#section2_container{
  background-image: linear-gradient($black-alpha0, $black 20%), url("~@/assets/imgs/home-section2-background.png");
  background-size: 100%;
  background-repeat: no-repeat;
}

#section2{
  font-family: Alliance No2;
}

#section2_subcontainer1{
  display: flex;
  flex-direction: column;
  width: 40%;
  margin: auto;
  padding: 64px 0;
  color: white;
  text-align: center;
}

#main_layout_v2.md #section2_subcontainer1,
#main_layout_v2.sm #section2_subcontainer1{
  width: 60%;
}

#main_layout_v2.xs #section2_subcontainer1{
  width: 90%;
}

#section2_subcontainer1 h1{
  font-family: Sunset Gothic Pro Heavy;
  margin-bottom: 15px;
}

#logo{
  width: 256px;
  margin: auto;
}

#section2_subcontainer2{
  width: 70%;
  margin: auto;
  margin-top: 100px;
  border-radius: 15px;
  background-image: linear-gradient(90deg, $black, $black-alpha0 65%), url("~@/assets/imgs/home-section2-subcontainer2-background.png");
  background-size: cover;
  background-position-x: 0, 75px;
  color: $white;
}

#main_layout_v2.xl #section2_subcontainer2{
  min-height: 500px;
}

#main_layout_v2.lg #section2_subcontainer2,
#main_layout_v2.md #section2_subcontainer2{
  width: 80%;
}

#main_layout_v2.sm #section2_subcontainer2{
  width: 80%;
  background-position-x: 0, -100px;
}

#main_layout_v2.xs #section2_subcontainer2{
  width: 80%;
  background-position-x: 0, -200px;
}

#main_layout_v2.xs #section2_subcontainer2{
  background-image: linear-gradient(90deg, $black, $black-alpha0 150%), url("~@/assets/imgs/home-section2-subcontainer2-background.png");
  background-position-x: 0 75px;
}

#section2_subcontainer2 h1{
  font-family: Sunset Gothic Pro Heavy;
}

#section2_subsubcontainer2{
  width: 35%;
  height: 100%;
  padding: 25px;
  padding-top: 75px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  background-image: linear-gradient($grey-5-alpha75, $black-alpha75 50%);
  border-radius: 15px;
}

#main_layout_v2.sm #section2_subsubcontainer2{
  width: 50%;
}

#main_layout_v2.xs #section2_subsubcontainer2{
  width: unset;
  background-image: unset;
}


#preorder{
  font-family: Bricolage Grotesque ExtraBold;
  color: $white;
  display: flex;
  justify-content: space-evenly;
  padding: 10px;
  width: 250px;
}

#main_layout_v2.md #preorder{
  font-size: 14px;
}

#section2_subcontainer3{
  color: $white;
  width: 70%;
  margin: auto;
  margin-top: 100px;
}

#main_layout_v2.lg #section2_subcontainer3,
#main_layout_v2.md #section2_subcontainer3{
  width: 80%;
}

#main_layout_v2.sm #section2_subcontainer3,
#main_layout_v2.xs #section2_subcontainer3{
  width: 80%;
}

#section2_subcontainer3_title{
  display: flex;
  justify-content: space-between;
}

#news_title{
  font-family: Bricolage Grotesque ExtraBold;
}

#main_layout_v2.xs #news_title{
  font-size: 0.8rem;
  padding-top: 3px;
}

#see_all_news{
  border-bottom: 1px solid $sunset-coral;
  font-family: Bricolage Grotesque ExtraBold;
}

#see_all_news a{
  color: $white;
}

#see_all_news a:hover{
  text-decoration: none;
}
</style>
